module.exports = {
    'temporary.load': '{current} of {max} views remaining',
    'temporary.until': 'Access until: {date}',
    'list.users': '{count} Users',
    'list.display': 'Displaying {start} - {end} of {max} files',
};